module.exports = __webpack_public_path__ + "static/media/briteU.b600f2d1.png";